import * as Tone from "tone";
import { PEAKS_WORKLET } from "./timing";

// The microphone, measured on the same clock as playback (Tone's audio context), so a hit's time
// compares directly with the time its note sounded. Browser processing (echo cancellation, noise
// suppression, automatic gain) is off: it would smear the attacks we time.
let workletModule = null;
export const canListen = () => typeof window !== "undefined" && Boolean(navigator.mediaDevices?.getUserMedia) && typeof window.AudioWorkletNode !== "undefined";

export async function openMicrophone(onPeak) {
  if (!canListen()) throw new Error("This browser can't listen to the microphone.");
  await Tone.start();
  const context = Tone.getContext(), raw = context.rawContext;
  let stream;
  try {
    stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false } });
  } catch (error) {
    throw new Error(error?.name === "NotAllowedError" || error?.name === "SecurityError"
      ? "TrueChops needs permission to use your microphone. Allow it from your browser’s address bar, then try again."
      : error?.name === "NotFoundError" ? "No microphone was found." : "Couldn’t start the microphone.");
  }
  if (!workletModule) workletModule = context.addAudioWorkletModule(URL.createObjectURL(new Blob([PEAKS_WORKLET], { type: "text/javascript" })));
  await workletModule;
  const source = raw.createMediaStreamSource(stream), node = context.createAudioWorkletNode("truechops-peaks");
  // A worklet only runs while connected to the output; this path is silent.
  const silence = raw.createGain();
  silence.gain.value = 0;
  source.connect(node); node.connect(silence); silence.connect(raw.destination);
  node.port.onmessage = ({ data }) => onPeak(data[0], data[1]);
  return {
    now: () => raw.currentTime,
    // Round-trip delay the device reports (calibration measures the real one).
    estimatedLatency: () => (raw.outputLatency || 0) + (raw.baseLatency || 0) + 0.01,
    close() {
      node.port.onmessage = null;
      try { source.disconnect(); node.disconnect(); silence.disconnect(); } catch { /* Already disconnected. */ }
      stream.getTracks().forEach((track) => track.stop());
    },
  };
}
